import { extendedRules } from '@/common/configs/extendedValidationRules'

require('../bootstrap')

import { createApp, defineComponent } from 'vue'
import App from './views/layouts/AppMember'
import router from './routes/member'
import i18n from './langs/lang'
import Constant from './configs/constant'
import VueCookie from 'vue-cookies'
import store from './stores/store'
import Loading from 'vue-loading-overlay'
import '@fortawesome/fontawesome-free/css/all.css'
import 'vue-loading-overlay/dist/css/index.css'
import 'tailwindcss/tailwind.css'
import { Form, Field, defineRule, configure } from 'vee-validate'
import { localize } from '@vee-validate/i18n'
import * as AllRules from '@vee-validate/rules'
import ApiService from './services/apiService'
import ConstantGenerate from '@/common/configs/constantGenerate'
import helper from '@/member/helpers/helper'
import vuetify from '@/plugins/vuetify'
import * as filters from '@/common/filters/index'

i18n.locale = VueCookie.get('locale') || 'ja'

const AppMember = createApp(App)

AppMember.config.globalProperties.$constantGenerate = ConstantGenerate
AppMember.config.globalProperties.$constantMember = Constant
AppMember.config.globalProperties.$apiService = ApiService
AppMember.config.globalProperties.$heplerMember = helper
AppMember.config.globalProperties.$filters = filters

AppMember.component('Loading', Loading)

// vee-validate config
AppMember.component('Form', Form)
AppMember.component('Field', Field)

Object.keys(AllRules).forEach(rule => {
  defineRule(rule, AllRules[rule])
})

Object.keys(extendedRules).forEach(rule => {
  defineComponent(rule, extendedRules[rule])
})

localize(i18n.locale)

window.axios.interceptors.response.use(
  function (response) {
    let dataToHandler = response.data

    return response
  },
  function (error) {
    if (!error.response) {
      return Promise.reject(error)
    }

    if (error.response.status == 401) {
      VueCookie.remove('auth_token')

      return (location.href = '/login')
    }

    return Promise.reject(error)
  }
)

AppMember.use(router)
AppMember.use(store)
AppMember.use(vuetify)
AppMember.use(i18n)

AppMember.mount('#app-member')

export default AppMember
